import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/infrastructure/LandmarkProjectsClient.tsx");
